export enum ConnectActionButtonsDataTestIds {
  EXPRESS_INTEREST_BUTTON = 'express-interest-button',
  SAVE_SCHOOL_BUTTON = 'connect-save-school-button',
}

export enum ConnectAlertsBannerDataTestIds {
  NOT_SUBSCRIBED_BANNER = 'connect-alerts-banner-not-subscribed',
  SUBSCRIBED_BANNER = 'connect-alerts-banner-subscribed',
}

export enum ConnectAuthenticatedAdminModalDataTestIds {
  ADMIN_MODAL = 'connect-authenticated-admin-modal',
  CANCEL_BUTTON = 'connect-authenticated-admin-modal-cancel-button',
  LOGOUT_BUTTON = 'connect-authenticated-admin-modal-logout-button',
  NAVBAR_ADMIN_MODAL = 'connect-navbar-authenticated-admin-modal',
  NAVBAR_ADMIN_MODAL_CANCEL_BUTTON = 'connect-navbar-authenticated-admin-modal-cancel-button',
  NAVBAR_ADMIN_MODAL_LOGOUT_BUTTON = 'connect-navbar-authenticated-admin-modal-logout-button',
}

export enum ConnectJobDiscoveryFiltersDataTestIds {
  DISTANCE_FILTER = 'connect-job-discovery-distance-filter-control',
  DISTRICT_FILTER = 'connect-job-discovery-district-filter-dropdown',
  GRADE_FILTER = 'connect-job-discovery-grade-level-filter',
  LOCATION_INPUT = 'connect-job-discovery-location-filter-input',
  LOCATION_MAP_CONTAINER = 'connect-job-discovery-location-filter-map-container',
  SCHOOL_SEARCH_FILTER = 'connect-job-discovery-school-search-filter',
  SUBJECTS_FILTER = 'connect-job-discovery-subject-filter',
  UPDATE_DISTANCE_FROM_LOCATION_SUBMIT_BUTTON = 'connect-job-discovery-location-filter-submit-button',
}

export enum ConnectJobDiscoveryGatedResultsCardDataTestIds {
  GATED_RESULTS_CARD = 'connect-job-discovery-gated-results-card-container',
  HEADER_TEXT = 'connect-job-discovery-gated-results-card-header-text',
  SIGNUP_BUTTON = 'gated-results-card-signup-button',
}

export enum ConnectJobDiscoverySchoolCardDataTestIds {
  SCHOOL_CARD = 'connect-job-discovery-school-card-container',
  LOADING_SPINNER = 'connect-job-discovery-school-card-loading-spinner',
  QUICK_APPLY_BUTTON = 'connect-job-discovery-school-card-quick-apply-button',
}

export enum ConnectLoginSignUpPageDataTestIds {
  EMAIL_INPUT = 'connect-login-sign-up-page-email-input',
  SUBMIT_BUTTON = 'connect-login-sign-up-page-submit-button-primary-button',
  TERMS_OF_SERVICE_STATEMENT = 'connect-login-sign-up-page-terms-of-service-statement',
  HEADER_TEXT = 'connect-login-sign-up-page-header-text',
  GOOGLE_LOGIN_BUTTON = 'connect-login-sign-up-page-google-login-button',
}

export enum ConnectRenewJobSeekingStatusPageDataTestIds {
  BODY_TEXT = 'connect-renew-job-seeking-status-page-body-text',
  CLOSE_MODAL_BUTTON = 'connect-renew-job-seeking-status-page-close-modal-button',
}

export enum ConnectMatchQuizAccessModalDataTestIds {
  MODAL = 'connect-match-quiz-access-modal',
  TAKE_QUIZ_BUTTON = 'connect-match-quiz-access-modal-take-quiz-button',
  IGNORE_BUTTON = 'connect-match-quiz-access-modal-not-right-now-button',
}

export enum ConnectMatchQuizAccessBannerDataTestIds {
  BANNER = 'connect-match-quiz-access-banner',
  CLOSE_BUTTON = 'connect-match-quiz-access-banner-close-button',
  IMAGE = 'connect-match-quiz-access-banner-image',
  SUBTITLE = 'connect-match-quiz-access-banner-subtitle-text',
  TAKE_QUIZ_BUTTON = 'connect-match-quiz-access-banner-take-quiz-button',
  TITLE = 'connect-match-quiz-access-banner-title-text',
}

export enum ConnectMatchQuizNavBarAccessButtonDataTestIds {
  BUTTON = 'connect-match-quiz-nav-bar-access-button',
}

export enum ConnectMagicLinkModalTestIds {
  HEADER_TEXT = 'magic-link-modal-header-text',
}

export enum ConnectMarketingInputAndButtonDataTestIds {
  COMPLETE_PROFILE_BUTTON = 'connect-marketing-banner-complete-profile-button',
  EMAIL_INPUT = 'marketing-email-input-jobs-discovery',
  SIGN_UP_BUTTON = 'marketing-sign-up-button',
  GOOGLE_LOGIN_BUTTON = 'marketing-google-sso-login-button',
  GOOGLE_LOGIN_BUTTON_PILL = 'marketing-google-sso-login-button-pill',
  GOOGLE_LOGIN_BUTTON_ICON = 'marketing-google-sso-login-button-icon',
}

export enum ConnectMoreInfoSliderDataTestIds {
  MORE_INFO_SLIDER = 'connect-job-discovery-more-info-slider',
  LOADING_SPINNER = 'connect-job-discovery-more-info-slider-loading-spinner',
}

export enum ConnectValuePropBannerDataTestIds {
  HEADER_TEXT = 'connect-job-discovery-value-prop-banner-header-text',
  SUB_HEADER_TEXT = 'connect-job-discovery-value-prop-banner-sub-header-text',
  SUB_HEADER_LINK_TEXT = 'connect-job-discovery-value-prop-banner-sub-header-link-text',
  IMAGE_ASSET = 'connect-job-discovery-value-prop-banner-image-asset',
  TERMS_OF_SERVICE_STATEMENT = 'connect-job-discovery-value-prop-banner-terms-of-service-statement',
}

export enum ConnectProfileFormDataTestIds {
  HEADER_TEXT = 'connect-profile-flow-profile-form-header-text',
  FIRST_NAME_INPUT = 'connect-profile-flow-profile-form-first-name-input',
  FIRST_NAME_QUESTION_LABEL = 'connect-profile-flow-profile-form-first-name-question-label',
  LAST_NAME_INPUT = 'connect-profile-flow-profile-form-last-name-input',
  LAST_NAME_QUESTION_LABEL = 'connect-profile-flow-profile-form-last-name-question-label',
  PHONE_NUMBER_INPUT = 'connect-profile-flow-profile-form-phone-number-input',
  PHONE_NUMBER_QUESTION_LABEL = 'connect-profile-flow-profile-form-phone-number-question-label',
  STATE_PREFERENCES_DROPDOWN = 'connect-profile-flow-profile-form-state-preferences-dropdown',
  STATE_PREFERENCES_QUESTION_LABEL = 'connect-profile-flow-profile-form-state-preferences-question-label',
  BUTTON_GROUP = 'connect-profile-flow-profile-form-button-group',
  SAVE_AND_CONTINUE_BUTTON = 'connect-profile-flow-profile-form-save-and-continue-button',
  OPT_IN_FOR_TEXT_MESSAGES_CHECKBOX = 'connect-profile-flow-profile-form-opt-in-for-text-messages-checkbox',
}

export enum ConnectQualificationsFormDataTestIds {
  ADD_CERTIFICATION_BUTTON = 'connect-profile-flow-qualifications-form-add-certification-button',
  CERTIFICATION_STATE_ERROR_TEXT = 'connect-profile-flow-qualifications-form-certification-state-error-text',
  CERTIFICATION_STATE_SELECT = 'connect-profile-flow-qualifications-form-certification-state-select',
  CERTIFICATION_SUBJECT_ERROR_TEXT = 'connect-profile-flow-qualifications-form-certification-subject-error-text',
  CERTIFICATION_SUBJECT_SELECT = 'connect-profile-flow-qualifications-form-certification-subject-select',
  CERTIFICATION_TOGGLE_RADIO_GROUP = 'connect-profile-flow-qualifications-form-certification-toggle-radio-group',
  CERTIFICATION_TOGGLE_YES_OPTION = 'connect-profile-flow-qualifications-form-certification-toggle-yes-option',
  CERTIFICATION_TOGGLE_NO_OPTION = 'connect-profile-flow-qualifications-form-certification-toggle-no-option',
  BUTTON_GROUP = 'connect-profile-flow-qualifications-form-button-group',
  BACK_BUTTON = 'connect-profile-flow-qualifications-form-back-button',
  CONTINUE_BUTTON = 'connect-profile-flow-qualifications-form-continue-button',
  REMOVE_CERTIFICATION_BUTTON = 'connect-profile-flow-qualifications-form-remove-certification-button',
  RESUME_ERROR_TEXT = 'connect-profile-flow-qualifications-form-resume-error-text',
  TEACHING_EXPERIENCE_ERROR_TEXT = 'connect-profile-flow-qualifications-form-teaching-experience-error-text',
  TEACHING_EXPERIENCE_SELECT = 'connect-profile-flow-qualifications-form-teaching-experience-select',
  UPLOAD_RESUME_TOOL = 'connect-profile-flow-qualifications-form-upload-resume-tool',
  DELETE_CERTIFICATION_BUTTON = 'connect-profile-flow-qualifications-form-delete-certification-button',
  VISA_TOGGLE_RADIO_GROUP = 'connect-profile-flow-qualifications-form-visa-toggle-radio-group',
  VISA_TOGGLE_YES_OPTION = 'connect-profile-flow-qualifications-form-visa-toggle-yes-option',
  VISA_TOGGLE_NO_OPTION = 'connect-profile-flow-qualifications-form-visa-toggle-no-option',
  LOADING_SPINNER = 'connect-profile-flow-qualifications-form-loading-spinner',
}

export enum ConnectQuickApplyDistrictJobboardRedirectModalDataTestIds {
  MODAL = 'connect-candidate-match-dashboard-quick-apply-district-jobboard-redirect-modal',
  HEADER_TEXT = 'connect-candidate-match-dashboard-quick-apply-district-jobboard-redirect-modal-header-text',
  QUICK_APPLY_BUTTON = 'connect-candidate-match-dashboard-quick-apply-district-jobboard-redirect-modal-quick-apply-button',
  EXPRESS_INTEREST_LINK = 'connect-candidate-match-dashboard-quick-apply-district-jobboard-redirect-modal-express-interest-link',
  DISTRICT_QUICK_APPLY_BUTTON = 'connect-candidate-match-dashboard-district-quick-apply-button',
}

export enum ConnectPreferencesFormDataTestIds {
  HEADER_TEXT = 'connect-profile-flow-preferences-form-header-text',
  LOADING_SPINNER = 'connect-profile-flow-preferences-form-loading-spinner',
  CONNECT_OPPORTUNITY_NO = 'connect-profile-flow-preferences-form-connect-opportunity-no-toggle',
  CONNECT_OPPORTUNITY_QUESTION_LABEL = 'connect-profile-flow-preferences-form-connect-opportunity-question-label',
  CONNECT_OPPORTUNITY_RADIO_GROUP = 'connect-profile-flow-preferences-form-connect-opportunity-radio-group',
  CONNECT_OPPORTUNITY_YES = 'connect-profile-flow-preferences-form-connect-opportunity-yes-toggle',
  DISTANCE_SLIDER = 'connect-profile-flow-preferences-form-distance-slider',
  GRADES_DROPDOWN = 'connect-profile-flow-preferences-form-grades-dropdown',
  GRADES_QUESTION_LABEL = 'connect-profile-flow-preferences-form-grades-question-label',
  JOB_SEEKING_STATUS_NO = 'connect-profile-flow-preferences-form-job-seeking-status-no-toggle',
  JOB_SEEKING_STATUS_QUESTION_LABEL = 'connect-profile-flow-preferences-form-job-seeking-status-question-label',
  JOB_SEEKING_STATUS_RADIO_GROUP = 'connect-profile-flow-preferences-form-job-seeking-status-radio-group',
  JOB_SEEKING_STATUS_YES = 'connect-profile-flow-preferences-form-job-seeking-status-yes-toggle',
  LOCATION_INPUT = 'connect-profile-flow-preferences-form-location-text-field-input',
  LOCATION_INPUT_ERROR = `connect-profile-flow-preferences-form-location-text-field-input-error`,
  LOCATION_MAP_CONTAINER = `connect-profile-flow-preferences-form-location-map-container`,
  LOCATION_QUESTION_LABEL = 'connect-profile-flow-preferences-form-location-question-label',
  BACK_BUTTON = 'connect-profile-flow-preferences-form-back-button',
  BUTTON_GROUP = 'connect-profile-flow-preferences-form-button-group',
  SAVE_AND_CONTINUE_BUTTON = 'connect-profile-flow-preferences-form-save-and-continue-button',
  SCHOOLS_TO_HIDE_FROM_DROPDOWN = 'connect-profile-flow-preferences-form-schools-to-hide-from-dropdown',
  SCHOOLS_TO_HIDE_FROM_QUESTION_LABEL = 'connect-profile-flow-preferences-form-schools-to-hide-from-question-label',
  SUBJECTS_DROPDOWN = 'connect-profile-flow-preferences-form-subjects-dropdown',
  SUBJECTS_QUESTION_LABEL = 'connect-profile-flow-preferences-form-subjects-question-label',
  NO_JOBS_FOUND_CONTINUE_BUTTON = 'connect-profile-flow-preferences-form-no-jobs-found-continue-button',
  NO_JOBS_FOUND_CLOSE_BUTTON = 'connect-profile-flow-preferences-form-no-jobs-found-close-button',
  JOB_SEEKING_STATUS_DROPDOWN = 'connect-profile-flow-preferences-form-job-seeking-status-dropdown',
}

export enum ConnectProfileFlowDataTestIds {
  STEPPER = 'connect-profile-flow-stepper',
  STEPPER_MOBILE = 'connect-profile-flow-stepper-mobile',
  STEPPER_DESKTOP = 'connect-profile-flow-stepper-desktop',
  PROFILE_FORM = 'connect-profile-flow-profile-form',
  QUALIFICATIONS_FORM = 'connect-profile-flow-qualifications-form',
  PREFERENCES_FORM = 'connect-profile-flow-preferences-form',
  CONNECT_ANNOUNCEMENT_BANNER = 'connect-profile-flow-announcement-banner',
  LEARN_MORE_LINK = 'connect-profile-flow-learn-more-link',
}

export enum ConnectMatchBannerDataTestIds {
  MATCHES_ANNOUNCEMENT_BANNER = 'connect-matches-banner',
  REDIRECT_LINK = 'connect-matches-banner-redirect-link',
  CLOSE_BUTTON = 'connect-matches-banner-close-button',
}

export enum ConnectRefreshActiveStatusBannerDataTestIds {
  REFRESH_ACTIVE_STATUS_BANNER = 'connect-refresh-active-status-banner',
  REFRESH_ACTIVE_STATUS_BANNER_YES_BUTTON = 'connect-refresh-active-status-banner-yes-button',
  REFRESH_ACTIVE_STATUS_BANNER_NO_BUTTON = 'connect-refresh-active-status-banner-no-button',
  REFRESH_ACTIVE_STATUS_BANNER_ERROR_SNACKBAR = 'connect-refresh-active-status-banner-error-snackbar',
}

export enum ConnectJobSeekingStatusDropdownDataTestIds {
  DROPDOWN = 'connect-job-seeking-status-dropdown',
  SUCCESS_TOAST = 'connect-job-seeking-status-dropdown-success-toast',
}
